import React from 'react';
import { gsap } from 'gsap';
import { ReactComponent as Svg } from '../../svg/message-talk.svg';
import './BtsMemberGuidePicture.css';

let nextTimeout = null;

const BtsMemberGuidePicture = ({
  loadedGallery,
  assetId,
  introId,
  onPictureClick,
  onClose,
}) => {
  const textElement = React.useRef(null);
  const [pageIndex, setPageIndex] = React.useState(0);
  const [autoPlayNext, setAutoPlayNext] = React.useState(false);

  const pages =
    'meta' in loadedGallery &&
    loadedGallery.meta &&
    'messages' in loadedGallery.meta &&
    assetId in loadedGallery.meta.messages
      ? loadedGallery.meta.messages[assetId]
      : [];

  const pageCount = pages.length;

  function prev() {
    clearTimeout(nextTimeout);
    setAutoPlayNext(false);
    if (pageIndex > 0) {
      setPageIndex(pageIndex - 1);
    }
  }

  function next(autoPlayValue = false) {
    clearTimeout(nextTimeout);
    if (autoPlayNext !== autoPlayValue) {
      setAutoPlayNext(autoPlayValue);
    }
    if (pageIndex < pageCount - 1) {
      setPageIndex(pageIndex + 1);
    }
  }

  function animateText(autoPlayNextValue = false) {
    clearTimeout(nextTimeout);
    const ps = textElement.current.getElementsByTagName('p');
    let delay = 0;
    let count = 0;
    for (const p of ps) {
      const spans = p.getElementsByTagName('span');
      for (const span of spans) {
        gsap.to(span, { duration: (autoPlayNextValue)? 0.1 : 0, delay: delay, alpha: 1 });
        if(autoPlayNextValue) {
          delay += span.textContent === ' ' ? 0.015 : 0.005 + Math.random() * 0.005;
        }
        count += 1;
      }
      if(autoPlayNextValue) {
        delay += 0.1;
      }
    }

    if (autoPlayNextValue) {
      nextTimeout = setTimeout(() => {
        next(true);
      }, delay * 1000 + Math.max(3000, count * 40));
    }
  }

  React.useEffect(() => {
    animateText(autoPlayNext);
    return () => {
      clearTimeout(nextTimeout);
    };
  }, [pageIndex, autoPlayNext]);

  React.useEffect(() => {
    setAutoPlayNext(true);
    if (pageIndex === 0) {
      animateText(true);
    }
    setPageIndex(0);
    return () => {
      clearTimeout(nextTimeout);
    };
  }, [assetId]);

  let messages =
    pages.length && pageIndex < pages.length ? pages[pageIndex] : [];

  messages = messages.map((message, i) => {

    const id = `${i}|${message.substr(0, 3)}`;

    let splited = message.split('');
    if (Intl && 'Segmenter' in Intl) {
      splited = [...new Intl.Segmenter().segment(message)].map(
        (x) => x.segment,
      );
    }
    const letters = splited.map((letter, letterIndex) => {
      return {
        value: letter,
        id: `${id}-${letterIndex}|${letter}`,
      };
    });
    return { letters, id };
  });

  const messageElements = messages.map((message) => {
    return (
      <p key={message.id}>
        {message.letters.map((letter) => {
          return <span key={letter.id}>{letter.value}</span>;
        })}
      </p>
    );
  });

  const messageClasses = [];
  if (messages.length) {
    messageClasses.push('message-activated');
  }

  if (assetId === introId) {
    messageClasses.push('message-intro');
  }

  return (
    <>
      <div id="bts-member-message" className={messageClasses.join(' ')}>
        <div ref={textElement}>{messageElements}</div>
        <Svg />
        <button
          id="bts-member-message-close"
          type="button"
          onClick={() => {
            onClose();
          }}
        >
          Close
        </button>
        {pageCount > 1 && (
          <>
            <button
              id="bts-member-message-next"
              type="button"
              onClick={next}
              className={
                pageIndex > pageCount - 2 ? 'bts-member-btn-disabled' : ''
              }
            >
              Next Page
            </button>
            <button
              id="bts-member-message-prev"
              type="button"
              onClick={prev}
              className={pageIndex < 1 ? 'bts-member-btn-disabled' : ''}
            >
              Previous Page
            </button>
          </>
        )}
      </div>
      <button
        type="button"
        id="bts-member-picture"
        onClick={() => {
          onPictureClick();
        }}
      >
        <img src={loadedGallery.meta.bts} alt={loadedGallery.meta.subtitle} />
      </button>
    </>
  );
};

export default BtsMemberGuidePicture;
